import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy .env.example to .env.local and set them.',
  );
}

export const supabase: SupabaseClient = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export const SUPABASE_URL = url;
if (typeof window !== 'undefined') (window as unknown as { supabase: typeof supabase }).supabase = supabase;
// Keep the Realtime socket authenticated with the user's JWT. RLS-filtered
// postgres_changes (pending actions, notifications) are only delivered to a
// subscriber whose token passes the table's RLS — the publishable key alone is
// evaluated as `anon` and the events are silently dropped. supabase-js doesn't
// reliably propagate the session token to Realtime with the new key format, so
// set it explicitly on load and on every auth change.
supabase.auth.getSession().then(({ data }) => {
  supabase.realtime.setAuth(data.session?.access_token ?? null);
}).catch(() => {});
supabase.auth.onAuthStateChange((_event, session) => {
  supabase.realtime.setAuth(session?.access_token ?? null);
});
